import MDFooter from 'md-footerjs';

import { DEFAULT_LANG, DEFAULT_THEME } from '@/config';

export type PrivateFooterProps = {
  theme?: string;
  lang?: string;
};

export const PrivateFooter = ({
  theme = DEFAULT_THEME,
  lang = DEFAULT_LANG,
}: PrivateFooterProps) => {
  return <MDFooter lang={lang} theme={theme} />;
};
